import { supabase } from "../utils/supabaseClient";

// ตรวจสอบค่าให้แน่ใจว่าโหลดมาครบ
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error("Missing Supabase Configuration!");
}

const FUNCTION_URL = `${SUPABASE_URL}/functions/v1/ai-scan`;
const SCAN_TIMEOUT_MS = 25000;
const MAX_RETRIES = 1;

function isLikelyConnectionDrop(err) {
  const msg = (err?.message || "").toLowerCase();
  return (
    msg.includes("failed to fetch") ||
    msg.includes("network") ||
    msg.includes("load failed") ||
    msg.includes("aborted") ||
    err?.name === "AbortError"
  );
}

async function invokeOnce(base64ImageData, mimeType, signal) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error("Unauthorized");

  const res = await fetch(FUNCTION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.access_token}`,
      apikey: SUPABASE_ANON_KEY,
    },
    body: JSON.stringify({ imageBase64: base64ImageData, mimeType }),
    signal,
  });

  // อ่าน response แบบปลอดภัย
  let data;
  try {
    data = await res.json();
  } catch (e) {
    throw new Error(`Invalid response format from AI: ${res.status}`);
  }

  if (!res.ok) {
    // ส่ง error จาก function ออกไปตรงๆ (เช่น 500 หรือ 429)
    throw new Error(data?.error || `AI Scan failed with status ${res.status}`);
  }
  
  return data;
}

export async function callGeminiVisionUltimate(base64ImageData, mimeType = "image/jpeg") {
  let lastErr = null;

  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    if (document.hidden) throw new Error("SCAN_INTERRUPTED_BACKGROUND");

    const controller = new AbortController();
    const wasHiddenDuringCall = { current: false };
    
    const onVisibilityChange = () => {
      if (document.hidden) wasHiddenDuringCall.current = true;
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    const timeoutId = setTimeout(() => controller.abort(), SCAN_TIMEOUT_MS);

    try {
      const result = await invokeOnce(base64ImageData, mimeType, controller.signal);
      
      clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      return result;
      
    } catch (err) {
      clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      
      lastErr = err;

      if (wasHiddenDuringCall.current) {
        throw new Error("SCAN_INTERRUPTED_BACKGROUND");
      }

      // Retry เฉพาะกรณี network เท่านั้น
      if (attempt < MAX_RETRIES && isLikelyConnectionDrop(err)) {
        console.warn(`Retry attempt ${attempt + 1} due to network drop`);
        await new Promise((r) => setTimeout(r, 1000));
        continue; 
      }
      
      break;
    }
  }

  // แปลง error ให้ UI อ่านง่าย
  if (isLikelyConnectionDrop(lastErr)) {
    throw new Error("SCAN_CONNECTION_DROPPED");
  }
  
  throw lastErr;
}